import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  useClientApiV1MockInterviewVoucherUserTypeQuery,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewVoucherUserTypeQuery {
  options?: Parameters<typeof useClientApiV1MockInterviewVoucherUserTypeQuery>[0]['options'];
}

export function useMockInterviewVoucherUserTypeQuery({
  options,
}: UseClientV1MockInterviewVoucherUserTypeQuery = {}) {
  return useClientApiV1MockInterviewVoucherUserTypeQuery({
    queryKey: getMockInterviewVoucherUserTypeQueryKey(),
    url: getMockInterviewVoucherUserTypeUrl(),
    options,
  });
}

export const getMockInterviewVoucherUserTypeQueryKey = (): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_VOUCHER_USER_TYPE,
];

export const getMockInterviewVoucherUserTypeUrl = (): string =>
  API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_VOUCHER_USER_TYPE;

export default useMockInterviewVoucherUserTypeQuery;
